import { getConsentBehaviour, getHasBlocksWithoutEnforcedPermissions, getIsWixApp } from '../selectors/appRuntimeReader';
import { ShowConsentBehaviour } from '@wix/ambassador-devcenter-appsruntimereader-v1-app-runtime-data/types';
export const shouldShowConsent = (app, consentPermissions, isAppAlreadyInstalled) => {
  const wixAppWithoutShowConsentFlag = getIsWixApp(app) && getConsentBehaviour(app) !== ShowConsentBehaviour.SHOW_CONSENT; // if wix app was config'd to always show consent, then this flag will be on

  const shouldShowConsentForLegacyBlocks = !wixAppWithoutShowConsentFlag && !isAppAlreadyInstalled && getHasBlocksWithoutEnforcedPermissions(app);
  return consentPermissions.length > 0 || shouldShowConsentForLegacyBlocks;
};
//# sourceMappingURL=shouldShowConsent.js.map